import { Box, Chip } from "@mui/material";

const styles = {
  box: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    mb: 2,
  },
  label: { whiteSpace: "nowrap", color: "#0103077F" },
};

const ChurchServiceItem = ({
  label,
  chips,
}: {
  label: string;
  chips: { time: string; baptismId: string }[];
}) => {
  if (!chips) return null;
  return (
    <Box sx={styles.box}>
      <Box
        sx={{
          display: "flex",
          alignContent: "center",
          flexWrap: "wrap",
          gap: "0.3rem",
        }}
      >
        {chips.map((c) => (
          <Chip
            key={c.baptismId}
            size="small"
            label={c.time}
            onClick={() => {
              const target = document.getElementById(c.baptismId);
              if (target) {
                target.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default ChurchServiceItem;
